import { render, staticRenderFns } from "./OtherConfig.vue?vue&type=template&id=02678101&scoped=true&"
import script from "./OtherConfig.vue?vue&type=script&lang=js&"
export * from "./OtherConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02678101",
  null
  
)

export default component.exports